<div class="association-card">
  <div class="association-name ">
    {{association.name}}
    <div class="association-city">
      <!--      {{association.address.city}}/{{association.address.district}}-->
    </div>
  </div>
  <div>
    <button type="button" class="btn btn-secondary btn-sm btn-access" (click)="onSelectAssociation()">
      <i class="bi bi-box-arrow-in-right"></i>
      Acessar
    </button>
  </div>
</div>
